import { render, staticRenderFns } from "./EventSearch.vue?vue&type=template&id=5fa93050&scoped=true&"
import script from "./EventSearch.vue?vue&type=script&lang=js&"
export * from "./EventSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa93050",
  null
  
)

export default component.exports